// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  worldId: __t.u64().name("world_id"),
  encounterId: __t.u64().name("encounter_id"),
  heroId: __t.u64().name("hero_id"),
  hpEnd: __t.i32().name("hp_end"),
  downed: __t.bool(),
  dealt: __t.i32(),
  taken: __t.i32(),
  finalBlows: __t.u32().name("final_blows"),
  xp: __t.u32(),
  gold: __t.u32(),
  outcome: __t.u8(),
  pulses: __t.u32(),
});
